var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slice 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtract",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,60 C46.5685,60 60,46.5685 60,30 C60,13.4315 46.5685,1.17422e-06 30,2.62268e-06 C13.4315,4.07115e-06 -4.07115e-06,13.4315 -2.62268e-06,30 L3,30 C3,15.0883 15.0883,3 30,3 C44.9117,3 57,15.0883 57,30 C57,44.9117 44.9117,57 30,57 L30,60 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Subtract-1",
    transform: "translate(10.000000, 10.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,20 C2,10.0589 10.0589,2 20,2 L20,0 C8.95431,0 0,8.95431 0,20 C0,31.0457 8.95431,40 20,40 C31.0457,40 40,31.0457 40,20 L38,20 C38,29.9411 29.9411,38 20,38 C10.0589,38 2,29.9411 2,20 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingwhite);
export default __webpack_public_path__ + "static/media/loadingwhite.bb4109991822afeb83433ba6d3a1d766.svg";
export { ForwardRef as ReactComponent };